import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";
import { scrollToId, waLink } from "@/config";

const LINKS = [
  { label: "Categories", id: "categories" },
  { label: "How it works", id: "how" },
  { label: "Get a price", id: "get-started" }
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "border-b border-ink/10 bg-ivory/85 backdrop-blur-md" : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="container-edit flex h-[72px] items-center justify-between">
        <button
          data-testid="nav-logo-button"
          onClick={() => window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.2 }) : window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to top"
        >
          <Logo />
        </button>

        <nav className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="group relative font-mono text-[11px] uppercase tracking-[0.25em] text-ink2 transition-colors hover:text-ink"
            >
              {l.label}
              <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-cyan transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-whatsapp-button"
            onClick={() => window.open(waLink("Hi! I want a better price on my trip."), "_blank")}
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-ocean px-5 py-2.5 text-[13px] font-semibold text-ivory transition-all duration-300 hover:bg-ocean-deep active:scale-[0.98]"
          >
            <MessageCircle className="h-4 w-4" />
            WhatsApp us
          </button>
          <button
            data-testid="nav-whatsapp-mobile-button"
            onClick={() => window.open(waLink("Hi! I want a better price on my trip."), "_blank")}
            aria-label="Chat on WhatsApp"
            className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-ocean text-ivory sm:hidden"
          >
            <MessageCircle className="h-4 w-4" />
          </button>
        </div>
      </div>
      <motion.div
        className="h-px origin-left bg-cyan/70"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.4, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
      />
    </header>
  );
};

export default Nav;
